export default "__VITE_ASSET__fkJlTTZy__"